import React from 'react';
import { useRemarkSync } from 'react-remark';
// using native anchor to avoid type issues from react-router typings mismatch
import { filtersList } from 'store/ducks/search/config';

type Counts = { all: number; news: number; catalog: number; pages: number };

type Item = {
    Title?: string;
    Date?: string;
    Reference?: string | null;
    Slug?: string | number | null;
    ShareCaption?: string | null;
    contentTypeUid?: string;
};

type Props = {
    status: string;
    counts: Counts;
    items: Item[];
    getItemLink: (item: Item) => string | null;
    labels?: {
        empty?: string;
    };
};

export const SearchResults: React.FC<Props> = ({ status, counts, items, getItemLink, labels }) => {
    return (
        <div className="search-result">
            {status === 'SUCCESS' && counts.all === 0 && (
                <div className="search-empty">{labels.empty || 'No results found'}</div>
            )}

            {items.map((item) => {
                const key = `${item.Title}-${item.Slug}`;
                const title = useRemarkSync(item.Title);
                const uid = item.contentTypeUid;
                const hasCategory = typeof uid === 'string' && Object.prototype.hasOwnProperty.call(filtersList, uid);
                const rawCategory = hasCategory ? (filtersList as any)[uid as string] : '';
                const category = rawCategory ? rawCategory.charAt(0).toUpperCase() + rawCategory.slice(1) : '';
                const link = getItemLink(item);
                
                const content = (
                    <>
                        {category && (<div className="search-item__category">{category}</div>)}
                        <div className="search-item__title">{title}</div>
                    </>
                );
                
                return (
                    <div className="search-item" key={key}>
                        {link ? (
                            <a href={link} className="search-item__link" aria-label={item.Title || 'Open'}>
                                {content}
                            </a>
                        ) : (
                            content
                        )}
                    </div>
                );
            })}
        </div>
    );
};


